import { apiUrls } from 'src/utils/properties';
import api, { Method } from '../../utils/apiManager.utils';
import { FileType } from 'src/enums';

const getStudentByEmail = async (email: string) => {
  return new Promise((resolve, reject) => {
    api(Method.GET, null, apiUrls.STUDENT + '/me', '', '', email)
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getStudentById = async () => {
  return new Promise((resolve, reject) => {
    api(Method.GET, null, apiUrls.STUDENT + apiUrls.GET_STUDENT, '', '', '')
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const updateStudent = async (data: Object) => {
  return new Promise((resolve, reject) => {
    api(
      Method.PUT,
      { 'Content-Type': 'multipart/form-data' },
      apiUrls.STUDENT,
      '',
      data,
      ''
    )
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const resetPasswordStudent = async (data: Object) => {
  return new Promise((resolve, reject) => {
    api(Method.PUT, null, apiUrls.STUDENT + `/resetPassword`, '', data, '')
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getStudentParentById = async (parentId: string) => {
  return new Promise((resolve, reject) => {
    api(Method.GET, null, apiUrls.STUDENT + apiUrls.PARENT, '', '', parentId)
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getSessions = async () => {
  return new Promise((resolve, reject) => {
    api(Method.GET, null, apiUrls.STUDENT + apiUrls.GET_SESSIONS)
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export {
  getStudentByEmail,
  updateStudent,
  resetPasswordStudent,
  getStudentById,
  getStudentParentById,
  getSessions
};
